<template>
  <div class="columns is-multiline">
    <div class="column is-half">
      <gallery-item mainurl="static/gallery/csn-full.jpg" mobileurl="static/gallery/csn-mobile.jpg" name="Corporate Suites Network" designer="Visible" n="1" ></gallery-item>
    </div>
    <div class="column is-half">
      <gallery-item mainurl="static/gallery/reina-full.jpg" mobileurl="static/gallery/reina-mobile.jpg" name="Reina Imaging" designer="Zimmer-Design" n="2" ></gallery-item>
    </div>
    <div class="column is-half">
      <gallery-item mainurl="static/gallery/trifecta-full.jpg" mobileurl="static/gallery/trifecta-mobile.jpg" name="Trifecta Sauces" designer="Zimmer-Design" n="3" ></gallery-item>
    </div>
    <div class="column is-half">
      <gallery-item mainurl="static/gallery/wlf-full.jpg" mobileurl="static/gallery/wlf-mobile.jpg" name="West Liberty Foods" designer="CSSI" n="4" ></gallery-item>
    </div>
    <div class="column is-half">
      <gallery-item mainurl="static/gallery/azar-full.jpg" mobileurl="static/gallery/azar-mobile.jpg" name="Azar Nut Company" designer="CSSI" n="5" ></gallery-item>
    </div>
    <div class="column is-half">
      <gallery-item mainurl="static/gallery/iac-full.jpg" mobileurl="" name="IA Collaborative" designer="IA Collaborative" n="6" ></gallery-item>
    </div>
    <div class="column is-half">
      <gallery-item mainurl="static/gallery/bvf-full.jpg" mobileurl="static/gallery/bvf-mobile.jpg" name="Bay Valley Foods" designer="CSSI" n="7" ></gallery-item>
    </div>
    <div class="column is-half">
      <gallery-item mainurl="static/gallery/pug-full.jpg" mobileurl="" name="Pug Story" designer="Visible" n="8" ></gallery-item>
    </div>
    <div class="column is-half">
      <gallery-item mainurl="static/gallery/yc-full.jpg" mobileurl="" name="The Young Center" designer="EPIC" n="9" ></gallery-item>
    </div>
    <div class="column is-half">
      <gallery-item mainurl="static/gallery/red-full.jpg" mobileurl="static/gallery/red-mobile.jpg" name="Red Moby" designer="Visible" n="10" ></gallery-item>
    </div>
    
  </div>
</template>

<style lang="scss" scoped>


</style>
<script>
import galleryItem from './Galleryitem'

export default {
  name: 'gallery',
  components: { 
    galleryItem
  }
}

</script>



// WEBPACK FOOTER //
// Gallery.vue?0ef1b6da